//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import pop from '@/mixin/pop';
export default {
  mixins: [pop],
  props: {
    friendList: {
      type: Array
    }
  },
  components: {
    Avatar: Avatar
  }
};